import { useEffect, useState } from "react";
import { FormProvider } from "../../../../../../common/provider/form/Form.provider";
import { CustomButton } from "../../../../../../common/components/CustomButton/CustomButton";
import { Form, Input, TimePicker } from "antd";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../../../common/components/simpleInput";
import { HatchCoverService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { InputSelect } from "../../../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../../../utilities/API_URLs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { handleNumericDecimalInput } from "../../../../../../common/utils/numericInputHandler";
dayjs.extend(utc);

type HatchCoverFormType = {
  onFinish: () => void;
  initialValue?: any;
};

const HatchCoverForm = ({ onFinish, initialValue }: HatchCoverFormType) => {
  const [form] = Form.useForm();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect (() => {
    if (initialValue) {
      form.setFieldsValue({
        ...initialValue,
        hatchCoverAction: initialValue.hatchCoverAction?.name,
        pannelPosition: initialValue.pannelPosition?.name,
        pannelType: initialValue.pannelType?.name,
        endAt: initialValue?.endAt ? dayjs(initialValue.endAt, "YYYY-MM-DD HH:mm") : dayjs(initialValue.createdAt, "DD/MM/YYYY HH:mm:ss").startOf("day"),
      })
    }
  })

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        hatchCoverAction: values.hatchCoverAction?.value,
        pannelPosition: values.pannelPosition?.value,
        pannelType: values.pannelType?.value,
        tonnage: values?.tonnage.toString(),
        bayNumber: parseInt(values?.bayNumber),
        endAt: dayjs(initialValue?.startAt, "DD/MM/YYYY HH:mm:ss")
          .set("hour", values?.endAt.hour())
          .set("minute", values?.endAt.minute())
          .set("second", 0)
          .format("YYYY-MM-DD HH:mm")
 };
      if (dataToPost?.id) {
        const res = await HatchCoverService.updateHatchCover(dataToPost);
        if (
          res?.status === HttpStatusCode.Ok ||
          res?.status === HttpStatusCode.Created
        ) {
          onFinish();
          //form.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
        </div>
        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            {/* Ligne 1 */}
            <div className={style.form__row}>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="Action"
                  name="hatchCoverAction"
                  rules={[{ required: true, message: "Ce champ est requis" }]}
                  customInput={
                      <InputSelect
                        uri={
                          API_URLs.operations.shifting.select.hatchCoverActionSelect
                        }
                        onChange={(e) => {
                          console.log("Selected load state:", e);
                        }}
                      />
                    }
                />
              </div>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="Panneau"
                  name="pannelPosition"
                  customInput={
                    <InputSelect
                      uri={
                        API_URLs.operations.shifting.select.pannelPositionSelect
                      }
                      onChange={(e) => {
                        console.log("Selected load state:", e);
                      }}
                    />
                  }
                />
              </div>
            </div>

            {/* Ligne 2 */}
            <div className={style.form__row}>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="N° de cale"
                  name="caleNumber"
                  customInput={<Input  />}
                />
              </div>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="N° bay"
                  name="bayNumber"
                  rules={[{ required: true, message: "Ce champ est requis" }]}
                  customInput={<Input  />}
                />
              </div>
            </div>

            {/* Ligne 4 */}
            {/* Ligne 4 */}
            <div className={style.form__row}>
              <div className={style.form__col}>
                <SimpleInput
                  Form={Form}
                  label="Type de panneau"
                  name="pannelType"
                  rules={[{ required: true, message: "Ce champ est requis" }]}
                  customInput={
                    <InputSelect
                      uri={
                        API_URLs.operations.shifting.select.pannelTypeSelect
                      }
                      onChange={(e) => {
                        console.log("Selected load state:", e);
                      }}
                    />
                  }
                />
              </div>
              <div className={`${style.form__col} ${style.qtyField}`}>
                <SimpleInput
                  Form={Form}
                  label="Tonnage (T)"
                  name="tonnage"
                  customInput={
                    <Input onKeyDown={handleNumericDecimalInput}/>
                  }
                />
              </div>
            </div>
            {/* Ligne 4 */}
            <div className={style.form__row}>
            <div className={`${style.form__col} ${style.form__time_picker}`}>
                <SimpleInput
                  Form={Form}
                  label="Heure de fin"
                  name={"endAt"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
              </div>
              <div className={`${style.form__col}`}>
              </div>
            </div>
          </div>
        </div>

          <div className={style.form__action_wrapper}>
            <CustomButton
              type="submit"
              className={style.form__action_button}
              isLoading={isLoadingSubmit}
            >
              Enregistrer
            </CustomButton>
          </div>
      </FormProvider>
    </div>
  );
};

export default HatchCoverForm;
